import { Typography } from 'components';
import ErrorSvg from 'assets/images/error_illustration_2.svg';
import styles from './CardError.module.css';

export const CardError = () => {
  return (
    <div className={styles.cardError}>
      <Typography variant='body-m' color='purple'>
        Oops! Try reloading
      </Typography>
      <img src={ErrorSvg} className={styles.errorImage} alt='Error' />
      <Typography variant='body-s' color='purple'>
        If this problem persists, please contact support at hello@tinyhealth.com
      </Typography>
    </div>
  );
};
